import { Flex, Radio, RadioGroup, Text } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectPageNumberShowOnPages } from 'modules/Editor/store/infographSelector';
import { setPageNumberShowOnPages } from 'modules/Editor/store/infographSlice';
import { useTranslation } from 'react-i18next';
import { ShowOnPage } from 'types/infographTypes';

import { labelWidth } from '../PageNumberMenu.config';
import { SHOW_ON_PAGES } from './ShowOnPageSelect.config';

const showOnPagesTestId = 'show-on-pages';

export const ShowOnPageSelect = () => {
  const showOnPages = useAppSelector(selectPageNumberShowOnPages);
  const dispatch = useAppDispatch();

  const onsetPageNumberShowOnPages = (newShow: ShowOnPage) => dispatch(setPageNumberShowOnPages(newShow));

  const { t } = useTranslation('common_navbar');
  const showOnPagesLabel = t('pageNumber.show-on-pages');
  const labelId = 'show-on-pages-label';

  return (
    <Flex gap={2} data-testid={showOnPagesTestId}>
      <Text fontSize='sm' id={labelId} w={labelWidth} fontWeight='medium'>
        {showOnPagesLabel}
      </Text>
      <RadioGroup
        aria-labelledby={labelId}
        name={showOnPagesLabel}
        onChange={onsetPageNumberShowOnPages}
        value={showOnPages}
        display='flex'
        flexDirection='column'
        gap={2}
      >
        {SHOW_ON_PAGES.map(({ value, label }) => {
          const labelText = t(`pageNumber.${label}` as any) as string;

          return (
            <Radio key={value} value={value} size='sm' fontWeight='normal'>
              {labelText}
            </Radio>
          );
        })}
      </RadioGroup>
    </Flex>
  );
};
